<template>
  <div class="facility-data">
    <v-icon class="mr-3" color="primary">icon-owner</v-icon>
    <div>
      <div class="facility-data__name">
        {{ name }}
      </div>
      <div class="facility-data__address">
        {{ address }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewItemFacilityData",
  props: {
    name: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.facility-data {
  display: flex;
  align-items: center;

  &__name,
  &__address {
    @include font-size(12px);
  }
  &__name {
    font-weight: 600;
  }
}
</style>
